<template>
  <div class="main">
    <Header 
      :show="true"
      title="用户列表"
      left="prepage" 
      right="create" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="这是用户信息元素，用于访问系统"
      />
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{row}">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="用户名">
                <span>{{ row.username }}</span>
              </el-form-item>
              <el-form-item label="人脸照片">
                <van-image
                  width="100px"
                  height="100px"
                  :src="row.faceImage"
                  @click="handleClickBindFaceDialog(row)"
                />
              </el-form-item>
              <el-form-item label="姓名">
                <span>{{ row.name }}</span>
              </el-form-item>
              <el-form-item label="类别">
                <span v-if="row.personType === 1">员工</span>  
                <span v-else-if="row.personType === 2">领导</span>  
                <span v-else-if="row.personType === 3">供应商</span>  
                <span v-else>其他</span>  
              </el-form-item>
              <el-form-item label="部门">
                <span>{{ row.department }}</span>
              </el-form-item>
              <el-form-item label="职位">
                <span>{{ row.position }}</span>
              </el-form-item>
              <el-form-item label="角色">
                <van-tag 
                  plain 
                  type="primary"
                  v-for="(item, index) in row.role"
                  :key="index"
                >
                  {{ item.name }}
                </van-tag>
              </el-form-item>
              <el-form-item label="手机号码">
                <span>{{ row.phone }}</span>
              </el-form-item>
              <el-form-item label="邮箱">
                <span>{{ row.email }}</span>
              </el-form-item>
              <el-form-item label="简介">
                <span>{{ row.summary }}</span>
              </el-form-item>
              <el-form-item label="企业微信" v-if="checkPermission([146])">
                <span v-if="row.wxwork !== ''" style="color: #67C23A;" @click="handleClickBindWxwork(row)">{{ row.wxwork }}</span>
                <span v-else style="color: #E6A23C;" @click="handleClickBindWxwork(row)">待绑定</span>
              </el-form-item>
              <el-form-item label="操作" v-if="checkPermission([143]) || checkPermission([144])" >
                <el-button v-if="checkPermission([143])" type="primary" size="mini" @click="handleClickUpdate(row)">
                  编辑
                </el-button>
                <el-button v-if="checkPermission([144])" type="danger" size="mini" @click="handleClickDelete(row)">
                  删除
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="id" align="center" width="50">
          <template slot-scope="{row}">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="name" align="center" show-overflow-tooltip min-width="110">
          <template slot-scope="{row}">
            {{ row.name }}
          </template>
        </el-table-column>
        <el-table-column label="部门" prop="department" align="center" show-overflow-tooltip min-width="80">
          <template slot-scope="{row}">
            {{ row.department }}
          </template>
        </el-table-column>
        <el-table-column label="职位" prop="position" align="center" show-overflow-tooltip min-width="80">
          <template slot-scope="{row}">
            {{ row.position }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination 
        v-show="table.total>0" 
        :total="table.total" 
        background 
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #FFFFFF;" />
      
      <van-dialog
        v-model="dialogVisibleBindFaceUpdate" 
        title="上传人脸照片"
        show-cancel-button
        :before-close="handleClickBindFaceUpdateConfirm"
      >
        <van-field
          label="访问区域"
          required
        >
          <template #input>
            <van-checkbox-group v-model="listQuery.area" direction="horizontal">
              <van-checkbox shape="square" icon-size="16px" :name="1">办公区</van-checkbox>
              <van-checkbox shape="square" icon-size="16px" :name="2">生产区</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field
          label="人脸照片"
          required
        >
          <template #input>
            <van-uploader 
              v-model="listQuery.image" 
              :max-count="1" 
              :before-read="beforeRead"
              :after-read="afterRead"
            />
          </template>
        </van-field>
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import * as imageConversion from 'image-conversion'
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getList, bindOne, createWhiteOne, deleteWhiteOne, deleteOne } from '@/api/staff.js'

  export default {
    name: "ServiceSystemStaff",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        dialogVisibleBindFaceUpdate: false,
        listQuery: {
          limit: 10,
          page: 1,
          id: null,
          serial: null,
          name: '',
          phone: '',
          area: [1],
          gate: 1,
          image: [],
          file: null,
          reason: '员工绿色通道',
          startDate: (new Date()).getTime(),
          endDate: (new Date()).getTime(),
          validEnable: 1
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        },
        loading: false,
        baseUrl: ''
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      const url = window.location.href
      this.baseUrl = url.substr(0, url.indexOf('/sywnq')) + '/sywnq'
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/staff/create', 
          query: {},
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          showPhoneAlarm(true, 'toast', null, 2000, null, '工程配置', '刷新完成')
        }, 1000)
      },
      beforeRead(file, detail) {
        if (file.type !== 'image/jpeg') {
          showPhoneAlarm(true, 'toast', null, 2000, 300, null, '请上传 jpg 格式图片')
          return false
        }
        return true
      },
      afterRead(file, detail) {
        return new Promise((resolve, reject) => {
          let isLt2M = file.file.size / 1024 / 1024 < 0.2 // 判定图片大小是否小于4MB
          if (isLt2M) {
            this.listQuery.file = file.file
            resolve(file)
          }
          const scale = parseFloat(1/(file.file.size / 1024 / 1024 / 0.2)).toFixed(2)
          imageConversion.compressAccurately(file.file, {
            size: 180,
            // scale: scale,
            width: 640
          }).then(res => {
            this.listQuery.file = res
            resolve(res)
          })
        })
      },
      handleClickBindFaceDialog(row) {
        if (!checkPermission([145])) {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '人脸信息', '您没有操作权限')
          return
        }
        if (row.faceImage === this.baseUrl) {
          this.listQuery.id = row.id
          this.listQuery.serial = row.serial
          this.listQuery.name = row.name
          this.listQuery.phone = row.phone
          this.dialogVisibleBindFaceUpdate = true
        } else {
          Dialog.confirm({
            title: '确认删除员工人脸信息？',
            message: '员工：' + row.name,
          }).then(() => {
            const data = {
              personOrderId: row.personOrderId
            }
            console.log(row)
            deleteWhiteOne(data).then(response => {
              const { data } = response
              if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '删除人脸信息', data.message)) {
                this.table.data[row.id - 1].faceImage = this.baseUrl
              }
            }).catch(function(error) {
              console.error(error)
            })
          }).catch(() => {
            showPhoneAlarm(true, 'toast', null, 2000, 200, '删除人脸信息', '取消')
          })
        }
      },
      handleClickBindFaceUpdateConfirm(action, done) {
        if (action === 'confirm') {
          if (this.listQuery.name === '') {
            showPhoneAlarm(true, 'toast', null, 2000, 300, null, '姓名不能为空')
            return
          }
          if (this.listQuery.area !== undefined && this.listQuery.area.length > 0) {
            if (this.listQuery.area.length === 1) {
              this.listQuery.gate = this.listQuery.area[0]
            } else {
              this.listQuery.gate = 3
            }
          }
          let data = new FormData()
          data.append("name", this.listQuery.name)
          data.append("phone", this.listQuery.phone)
          data.append("gate", this.listQuery.gate)
          data.append("image", this.listQuery.file)
          data.append("reason", this.listQuery.reason)
          data.append("startDate", this.listQuery.startDate)
          data.append("endDate", this.listQuery.endDate)
          data.append("validEnable", this.listQuery.validEnable)
          createWhiteOne(data, this.listQuery.serial).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '添加人脸白名单', data.message)) {
              this.handleClickQuery()
            }
            done(true)
          }).catch(function(error) {
            console.error(error)
          })
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消上传')
          done(true)
        }
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit
        }
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data.items
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              let url = this.baseUrl + items[i].avatar
              if (items[i].faceImgUrl !== '') {
                url = this.baseUrl + items[i].faceImgUrl
              }
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                avatar: items[i].avatar,
                faceImage: url,
                username: items[i].username,
                name: items[i].name,
                department: items[i].department,
                position: items[i].position,
                role: items[i].role,
                phone: items[i].phone,
                email: items[i].email,
                personType: items[i].personType,
                personOrderId: items[i].personOrderId,
                wxoa: items[i].wxoa,
                wxwork: items[i].wxwork,
                remark: items[i].remark,
                sex: items[i].sex,
                birthday: parseTime(items[i].birthday, '{y}-{m}-{d}'),
                hiredate: parseTime(items[i].hiredate, '{y}-{m}-{d}'),
                address: items[i].address,
                permission: items[i].permission
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickUpdate(row) {
        // this.$router.push({ path:'/service/system/staff/update', query: row })
        let role = []
        for (let i=0; i<row.role.length; i++) {
            role.push(row.role[i].id)
        }
        const roleStr = role.join(';')
        console.log(roleStr)
        let permission = []
        for (let i=0; i<row.permission.length; i++) {
            permission.push(row.permission[i].id)
        }
        const permissionStr = permission.join(';')
        console.log(permissionStr)
        this.$router.push({ 
          path:'/service/system/staff/update', 
          query: {
            serial: row.serial,
            username: row.username,
            name: row.name,
            department: row.department,
            position: row.position,
            role: roleStr,
            permission: permissionStr,
            phone: row.phone,
            email: row.email,
            wxwork: row.wxwork,
            remark: row.remark,
            personType: row.personType
          },
        })
      },
      handleClickBindWxwork(row) {
        if (!checkPermission([146])) {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '绑定企业微信', '您没有操作权限')
          return
        }
        let title = '确定绑定企业微信？'
        if (row.wxwork !== '') {
          title = '确定更新企业微信？'
        }
        Dialog.confirm({
          title: title,
          message: '员工：' + row.name,
        }).then(() => {
          this.loading = true
          const data = {
            name: row.name
          }
          bindOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '绑定企业微信', data.message)) {
              this.handleClickQuery()
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '绑定企业微信', '取消')
        })
      },
      handleClickDelete(row) {
        Dialog.confirm({
          title: '确认删除员工信息？',
          message: '员工：' + row.name,
        }).then(() => {
          this.loading = true
          const data = {
            id: row.serial
          }
          deleteOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '删除', data.message)) {
              this.table.data.splice(this.table.data.indexOf(row), 1)
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '删除', '取消')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
